import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router, Params } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { of } from 'rxjs';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { catchError, filter, map, shareReplay, switchMap, tap } from 'rxjs/operators';
import { ConferenceResource } from 'src/app/models/iconference.interface';
import { CodeValue } from 'src/app/models/ikeyvalue.interface';
import { PersonOnlineRegForm } from 'src/app/models/iperson.interface';
//import { MetaDynamicService } from 'src/app/services/common/meta-dynamic.service';
import { ConferenceService } from 'src/app/services/data/conference.service';
import { RegService } from 'src/app/services/data/reg.service';
import { MenuItem, MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { ThesesService } from 'src/app/services/data/theses.service';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-new-theses',
  templateUrl: './new-theses.component.html',
  styleUrls: ['./new-theses.component.css'],
  providers: [ MessageService ]
})
export class NewThesesComponent implements OnInit {
  // TODO: add conf alias form route
  // src/app/registration-online/registration-online-form/registration-online-form.component.ts

  confName: string;

  _alias: string;

  items: MenuItem[];

  subscription: Subscription;

  constructor(
    public messageService: MessageService,
    public conferenceService: ConferenceService,
    public _router: ActivatedRoute,
    private thesesService: ThesesService,
    private _meta: Meta,
    private _title: Title,
    ) {

    }

  private _refresh$ = new BehaviorSubject<boolean>(true);
  private _needRefresh$ = this._refresh$.asObservable();

  conference$: Observable<ConferenceResource> = combineLatest([this._router.paramMap, this._needRefresh$]).pipe(
    map(data => data[0]),
    tap((params: ParamMap) => this._alias = params.get('alias')),
    switchMap((params: ParamMap) => this.conferenceService.getAlias(params.get('alias'))),
    tap(conf => {
      this.confName = conf.nameOfficial;
      // console.log('NEWConf: ' + this.confName);
      this.thesesService.setConferenceName(this.confName);
      this._meta.addTag({ name: 'title', content: conf.nameOfficial });
      this._meta.addTag({ name: 'description', content: conf.location });
      this._title.setTitle(conf.nameOfficial)
      // console.log('-------'+this.thesesService.getConferenceName());
    }),
    shareReplay()
  );

  ngOnInit() {

    this.thesesService.initResource();
    // console.log(this.thesesService.getTheses());

    this.items = [
      {
        label: 'Автор(-ы)',
        icon: 'pi pi-user',
        routerLink: `authors`
      },
      {
        label: 'Данные о тезисе',
        icon: 'pi pi-book',
        routerLink: `theses-data`
      },
      {
        label: 'Готово',
        icon: 'pi pi-upload',
        routerLink: `done`
      }
    ];
  }
}
